<template>
    <div class="intro-page">
        <div class="intro-title">
            <span class="sp1">游戏简介</span>
            <span class="sp2">Game Introduction</span>
        </div>
        <div class="intro-title-line">
            <div class="active-line"></div>
        </div>
        <div class="content">
            <div>
                <img src="../../assets/intro/1.png" alt="" />
                <div class="dl-btn" @click="dlClient" data-agl-cvt="6"></div>
            </div>
            <div>
                <img src="../../assets/intro/2.png" alt="" />
            </div>
            <div>
                <img src="../../assets/intro/3.png" alt="" />
            </div>
            <div>
                <img src="../../assets/intro/4.png" alt="" />
            </div>
            <div>
                <img src="../../assets/intro/5.png" alt="" />
            </div>
            <div>
                <img src="../../assets/intro/6.png" alt="" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'IntroPage',
    mounted() {
        $('body').addClass('intro-bg')
    },
    beforeDestroy() {
        $('body').removeClass('intro-bg')
    },
    methods: {
        dlClient() {
            this.$EventBus.$emit('dl-client')
        }
    }
}
</script>
<style lang="less" scoped>
.intro-page {
    margin: 0 auto;
    width: 1200px;
    min-height: 1200px;
    padding-top: 140px;

    .intro-title {
        span {
            vertical-align: bottom;
        }

        .sp1 {
            font-weight: bold;
            font-size: 30px;
            line-height: 30px;
            color: #ffffff;
            background: linear-gradient(0deg, #ffffff 34.2041015625%, #c1c6c3 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .sp2 {
            position: relative;
            font-size: 16px;
            color: @color-txt-normal;
            margin-left: 14px;
            top: 5px;
        }
    }

    .intro-title-line {
        position: relative;
        margin-top: 12px;
        margin-bottom: 40px;
        width: 294px;
        height: 1px;
        background-color: @bg-color-00;

        .active-line {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            width: 119px;
            height: 3px;
            background: #00eb57;
            border-radius: 2px;
        }
    }

    .content {
        & > div {
            position: relative;

            img {
                width: 100%;
                display: block;
            }

            .dl-btn {
                cursor: pointer;
                position: absolute;
                top: 181px;
                left: 323px;
                width: 112px;
                height: 36px;
                background: url(../../assets/intro/dl-btn.png) no-repeat center/100%;

                &:hover {
                    background-image: url(../../assets/intro/dl-btn-h.png);
                }
            }
        }
    }
}
</style>
